<template>
  <v-app id="app" v-if="$route.meta.vuetify !== false">
    <link
        href="https://fonts.googleapis.com/css?family=Material+Icons"
        rel="stylesheet"
    />
    <link href="https://fonts.googleapis.com/css2?family=Inter" rel="stylesheet">

    <Snackbar />
    <router-view />

  </v-app>
  <!-- Sinon, bypass complet de Vuetify -->
  <div v-else>
    <router-view />
  </div>
</template>

<style>
@font-face {
  font-family: 'Material Symbols Outlined';
  src: url('~@/assets/material-symbols-outlined.woff2') format('woff2');
  font-weight: 100 700;
  font-stretch: 75% 125%;
}
</style>

<script>

export default {};
</script>

<style lang="sass">
@import "~@/styles/style.scss"
</style>